module.exports = __webpack_public_path__ + "img/7.34d5c757.jpg";